import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { FileService } from "../../../../core/services/FileService";
import usePaginator from "../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _AddCommercialCampaign } from "../../../../core/services/dataBean/EntityCatalogVdos";



interface Props {
    idCommercialCampaign: number;
}
export const CommercialCampaignItem = ({ idCommercialCampaign }: Props) => {

    const comeriem = useDataBean(_AddCommercialCampaign);
    const paginador = usePaginator();
    const [IDProduct, setIDProduct] = useState<any>(null);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const fileService = new FileService();
    useEffect(() => {
        getLista();
    }, [idCommercialCampaign, paginador.page])

    const getLista = () => {

        comeriem.instance.getCommercialCampaignItemCatalog(idCommercialCampaign, IDProduct, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        comeriem.setBean({
            IDCommercialCampaign: idCommercialCampaign
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        comeriem.instance.deleteCommercialCampaignItem(comeriem.bean.IDCommercialCampaignItem).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        comeriem.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCommercialCampaignItem', visible: true },
        { title: 'Producto', property: 'IDProduct', visible: true },
        { title: 'Unidad de Medida', property: 'UBLMeasurementUnitName', visible: true },
        { title: 'Código Unidad de Medida', property: 'UBLMeasurementUnitCode', visible: true },
        { title: 'Referencia', property: 'Reference', visible: true },
        { title: 'Código de Producto', property: 'ProductCode', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Valor Unitario', property: 'PriceValue', visible: true },
        { title: 'Descuento Mínimo', property: 'MinDiscount', visible: true },
        { title: 'Descuento Máximo', property: 'MaxDiscount', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Productos de la Campaña</label>
            <div className="col-md-6">
                <SelectProductEditor label="Producto" value={IDProduct} onChange={(e) => { setIDProduct(e.IDProduct) }} />
            </div>
            <div className="col-md-6 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={comeriem.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Valor Unitario</label>
                            <input type="text" className="form-control" name='PriceValue' value={comeriem.bean.PriceValue} onChange={(e) => { comeriem.setBean({ ...comeriem.bean, "PriceValue": e.target.value }) }} />
                        </div>

                        <div className="col-md-6">
                            <label>Descuento Mínimo</label>
                            <input type="text" className="form-control" name='MinDiscount' value={comeriem.bean.MinDiscount} onChange={(e) => { comeriem.setBean({ ...comeriem.bean, "MinDiscount": e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Descuento Máximo</label>
                            <input type="text" className="form-control" name='MaxDiscount' value={comeriem.bean.MaxDiscount} onChange={(e) => { comeriem.setBean({ ...comeriem.bean, "MaxDiscount": e.target.value }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" name='Description' value={comeriem.bean.Description} onChange={(e) => { comeriem.setBean({ ...comeriem.bean, "Description": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {comeriem.bean.Name}</strong>
                </ModalConfirm>
            </div>
        </div>

    )
}